import PageHeader from "../components/PageHeader";
import { COMPANY } from "../data/content";

const sections = [
  {
    title: "1. Who We Are",
    body: `${COMPANY.name} ("Vaskion Technologies", "we", "us") is a software development, AI and IT solutions company. This Privacy Policy explains how we handle information you share with us through this website (${COMPANY.website}).`,
  },
  {
    title: "2. Information We Collect",
    body: "When you contact us through this website or by email, we may collect the information you choose to provide, such as your name, business email address, phone number, company name and details about your project or enquiry. We do not ask for more information than is needed to respond to you.",
  },
  {
    title: "3. How We Use Your Information",
    body: "We use the information you provide only to respond to your enquiry, discuss a potential engagement and communicate with you about our services. With your consent, given through our contact form, we may use your details to respond to your enquiry. We do not sell your information to third parties.",
  },
  {
    title: "4. How Long We Keep Your Information",
    body: "We keep enquiry information only for as long as needed to handle your request and any follow-up discussion, after which it is removed or anonymised unless a business engagement requires us to retain it.",
  },
  {
    title: "5. Sharing of Information",
    body: "We do not share your personal information with third parties except where required by law, or where a trusted service provider supports our operations under appropriate confidentiality obligations.",
  },
  {
    title: "6. Data Security",
    body: "We apply reasonable technical and organisational measures to protect the information you share with us against unauthorised access, loss or misuse.",
  },
  {
    title: "7. Your Choices",
    body: `You may ask us at any time to access, correct or delete the personal information you have shared with us by writing to ${COMPANY.email}.`,
  },
  {
    title: "8. Changes to This Policy",
    body: "We may update this Privacy Policy from time to time. The current version will always be published on this page.",
  },
  {
    title: "9. Contact",
    body: `For any questions about this Privacy Policy or how we handle your information, please contact us at ${COMPANY.email}.`,
  },
];

const PrivacyPolicy = () => (
  <main data-testid="privacy-policy-page">
    <PageHeader
      eyebrow="Legal"
      title="Privacy Policy"
      description="How Vaskion Technologies handles the information you share with us."
    />
    <section className="bg-white py-16 lg:py-20">
      <div className="container-site max-w-3xl">
        {sections.map((section) => (
          <article key={section.title} className="border-b border-border py-8 first:pt-0 last:border-0">
            <h2 className="text-lg font-semibold">{section.title}</h2>
            <p className="mt-3 text-base leading-relaxed text-brand-grey">{section.body}</p>
          </article>
        ))}
        <p className="mt-8 text-sm text-neutral-500">Last updated: 2026.</p>
      </div>
    </section>
  </main>
);

export default PrivacyPolicy;
